const defaultStats = () => ({
  analysis: {},
  variants: {},
  images: {},
  videos: {},
});

let currentStats = defaultStats();
let onStatsChange = null;

export const initModelStats = (stats, onChange) => {
  currentStats = {
    analysis: stats?.analysis || {},
    variants: stats?.variants || {},
    images: stats?.images || {},
    videos: stats?.videos || {},
  };
  onStatsChange = typeof onChange === "function" ? onChange : null;
};

const updateBucket = (bucket, model, updater) => {
  const safeModel = model || "unknown";
  const existing = bucket[safeModel] || {
    count: 0,
    totalMs: 0,
    minMs: null,
    maxMs: null,
    errors: 0,
  };
  bucket[safeModel] = updater(existing);
};

export const recordTiming = ({ category, model, ms, ok = true }) => {
  if (!category) return;
  const stats = currentStats || defaultStats();
  const bucket = stats[category] || {};
  updateBucket(bucket, model, (entry) => {
    const next = { ...entry };
    if (Number.isFinite(ms)) {
      next.count += 1;
      next.totalMs += ms;
      next.minMs = next.minMs === null ? ms : Math.min(next.minMs, ms);
      next.maxMs = next.maxMs === null ? ms : Math.max(next.maxMs, ms);
    }
    if (!ok) {
      next.errors += 1;
    }
    return next;
  });
  stats[category] = bucket;
  currentStats = stats;
  onStatsChange?.(currentStats);
};

export const recordError = ({ category, model }) => {
  if (!category) return;
  const stats = currentStats || defaultStats();
  const bucket = stats[category] || {};
  updateBucket(bucket, model, (entry) => ({
    ...entry,
    errors: (entry.errors || 0) + 1,
  }));
  stats[category] = bucket;
  currentStats = stats;
  onStatsChange?.(currentStats);
};

export const getModelStats = () => currentStats || defaultStats();
